<div class="row">
    <div class="col-xl-9 col-md-12">
        <div id="clientList" class="card">
            <ng-container *ngTemplateOutlet="pickList"></ng-container>
        </div>
    </div>
    <div class="col-xl-3 padding-top">
        <ng-container *ngTemplateOutlet="profileView"></ng-container>
    </div>
</div>


<ng-template #profileView>
    <div class="card" id="contact-view-detail">

        <div class="card-body p-3 ">
            <div style="text-align: end;">
                <button [disabled]="(model.id == undefined)" class="btn badge bg-light text-primary fs-12 "
                    (click)="openModalEdit(model.id, $event)">
                    <div style="display: inline-flex; padding-top: 2px;">
                        <i class="ri-edit-box-line align-bottom me-1"></i>
                        <div style="text-align: center;" i18n="@@">Edit</div>
                    </div>
                </button>
            </div>

            <div class="text-center">

                <div class="profile-user position-relative d-inline-block mx-auto">
                    <div class="position-relative d-inline-block">
                        <img [src]="profilePhotoPNGTransform(model)" alt=""
                            class="avatar-lg rounded-circle img-thumbnail">
                        <span class="contact-active position-absolute rounded-circle bg-success"></span><span
                            class="visually-hidden"></span>
                    </div>
                    <h5 class="mt-4 mb-1" i18n="@@">{{model.fullName || "Not Provided"}}</h5>
                    <p class="text-muted" i18n="@@">{{model.companyName || "Not Provided"}}</p>
                </div>
            </div>
        </div>
        <div style="border-bottom: 1px solid #e9ebec ;"></div>

        <div class="card-body">
            <div class="mb-3">
                <h6 class="text-muted text-uppercase fw-semibold mb-3 " i18n="@@">Contact Information</h6>
                <div class="table-responsive table-card">
                    <table class="table table-borderless mb-0">
                        <tbody>
                            <tr>
                                <td class="fw-medium" scope="row" i18n="@@">Contact Organization</td>
                                <td class="designation" i18n="@@">{{model.companyName || "Not Provided"}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-success text-success rounded bx bx bx-phone"
                                        style="padding: 3px;"></i> Phone No</td>
                                <td class="email" i18n="@@">{{model.phoneNumber || "Not Provided"}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-danger text-danger rounded bx bx-mail-send"
                                        style="padding: 3px;"></i> Email </td>
                                <td class="phone" i18n="@@">{{model.email || "Not Provided"}}</td>
                            </tr>
                            <tr>
                                <td class="fw-medium gap-2 " scope="row" i18n="@@"><i
                                        class="bg-soft-warning text-warning rounded bx bx-printer"
                                        style="padding: 3px;"></i> Fax No</td>
                                <td class="l_score" i18n="@@">{{model.faxNumber || "Not Provided"}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <ul ngbNav #customNav="ngbNav" [activeId]="1"
                class="nav nav-tabs-custom rounded card-header-tabs border-bottom-0center justify-content-center"
                role="tablist">

                <li [ngbNavItem]="1" class="nav-item">
                    <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                        <i class="far fa-user"></i>
                        Address Information
                    </a>
                    <ng-template ngbNavContent>
                        <table class="table table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Unit</td>
                                    <td class="designation" i18n="@@">{{model.address.unit || "Not Provided"}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Street</td>
                                    <td class="email" i18n="@@">{{model.address.address1 || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">City</td>
                                    <td class="phone" i18n="@@">{{model.address.city || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Province</td>
                                    <td class="l_score" i18n="@@">{{model.address.province || "Not Provided"}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Country</td>
                                    <td class="l_score" i18n="@@">{{model.address.country || "Not Provided"}}</td>
                                </tr>
                                <tr>
                                    <td class="fw-medium" scope="row" i18n="@@">Postal Code</td>
                                    <td class="l_score" i18n="@@">{{model.address.postalCode || "Not Provided"}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-template>
                </li>
            </ul>
            <div class="tab-content" style="padding-top: 20px;">
                <div [ngbNavOutlet]="customNav"></div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #pickList>
    <app-list-layout [tableConfig]="tableConfig" [listItems]="listItems" [listService]="contactListService"
        [sortBy]="sortBy" (buttonActionSelected)="buttonActionSelected($event)"  (updateCheckedValues)="checkedValGet =  $event"
        (rowActionSelected)="rowActionSelected($event)" (filterSelected)="filterSelected($event)"
        (sortSelected)="sortByPassedSort($event)" 
        (resetListLayout) = "contactListService.resetListState($event)"
        (searchTermChanged)="contactListService.searchTerm = $event"
        (paginationSelected)="paginationUpdated(contactListService,$event)" [serviceData]="serviceData"
        (pageSizeSelected) = "contactListService.pageSize = $event"
    ></app-list-layout>
</ng-template>